<template>
  <a-card :bordered="false">
    <a-row :gutter="24">
      <a-col :span="24">
        <!-- 条件搜索 -->
        <div class="table-page-search-wrapper" :class="{ 'is-collapsed': !advanced }">
          <a-form layout="inline">
            <a-row :gutter="[16, 8]">
              <!-- 设备名称 -->
              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="设备名称" prop="name">
                  <a-input
                    v-model:value="queryParam.name"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>
              <!-- 设备码 -->
              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="设备编码" prop="equipmentCode">
                  <a-input
                    v-model:value="queryParam.equipmentCode"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>
              <!-- 设备型号 -->
              <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                <a-form-item label="设备型号" prop="equipmentModel">
                  <a-input
                    v-model:value="queryParam.equipmentModel"
                    placeholder="请输入"
                    allow-clear
                    class="no-border-radius-input"
                  />
                </a-form-item>
              </a-col>

              <!-- 按钮区域：默认在第一行，展开后在最后一行 -->
              <a-col v-if="!advanced" :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24" class="search-actions-col">
                <a-form-item>
                  <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                    <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                    <span class="search-actions-group">
                      <a-button @click="resetQuery" class="no-border-button">重置</a-button>
                      <a-button @click="toggleAdvanced" class="no-border-button toggle-button">
                        {{ advanced ? '收起' : '展开' }}
                        <UpOutlined v-if="advanced" />
                        <DownOutlined v-else />
                      </a-button>
                    </span>
                  </span>
                </a-form-item>
              </a-col>

              <!-- 高级搜索条件（展开后显示） -->
              <template v-if="advanced">
                <!-- 定位器MAC -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="定位器MAC" prop="wristbandMac">
                    <a-input
                      v-model:value="queryParam.wristbandMac"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <!-- 生产厂家 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="生产厂家" prop="manufactor">
                    <a-input
                      v-model:value="queryParam.manufactor"
                      placeholder="请输入"
                      allow-clear
                      class="no-border-radius-input"
                    />
                  </a-form-item>
                </a-col>
                <!-- 设备类型 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="设备类型" prop="type">
                    <a-select
                      v-model:value="queryParam.type"
                      placeholder="请选择"
                      allow-clear
                      style="width: 100%"
                      class="no-border-radius-select"
                    >
                      <a-select-option v-for="(d, index) in dict.type['device_type']" :key="index" :value="d.value">{{
                        d.label
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <!-- 保养周期类型 -->
                <!--              <a-col :md="6" :sm="24">-->
                <!--                <a-form-item label="保养周期类型" prop="maintenanceCycle">-->
                <!--                  <a-select-->
                <!--                    v-model:value="queryParam.maintenanceCycle"-->
                <!--                    placeholder="请选择"-->
                <!--                    allow-clear-->
                <!--                    style="width: 100%"-->
                <!--                    class="no-border-radius-select"-->
                <!--                  >-->
                <!--                    <a-select-option-->
                <!--                      v-for="(d, index) in dict.type[-->
                <!--                        'equipment_maintenance_cycle_type'-->
                <!--                      ]"-->
                <!--                      :key="index"-->
                <!--                      :value="d.value"-->
                <!--                      >{{ d.label }}</a-select-option-->
                <!--                    >-->
                <!--                  </a-select>-->
                <!--                </a-form-item>-->
                <!--              </a-col>-->
                <!-- 保养周期 -->
                <!--              <a-col :md="6" :sm="24">-->
                <!--                <a-form-item label="保养周期" prop="maintenanceFrequency">-->
                <!--                  <a-input-number-->
                <!--                    v-model:value="queryParam.maintenanceFrequency"-->
                <!--                    :min="0"-->
                <!--                    placeholder="请输入"-->
                <!--                    class="no-border-radius-input-number"-->
                <!--                  />-->
                <!--                </a-form-item>-->
                <!--              </a-col>-->
                <!-- 是否需要耗材 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="是否需要耗材" prop="isConsumables">
                    <a-select
                      v-model:value="queryParam.isConsumables"
                      placeholder="请选择"
                      allow-clear
                      style="width: 100%"
                      class="no-border-radius-select"
                    >
                      <a-select-option
                        v-for="(d, index) in dict.type['equipment_require_consumables']"
                        :key="index"
                        :value="d.value"
                        >{{ d.label }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <!-- 保修截止日期 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="保修截止日期" prop="guaranteeTimeStart">
                    <a-range-picker
                      style="width: 100%"
                      v-model:value="guaranteeTimeRange"
                      format="YYYY-MM-DD"
                      valueFormat="YYYY-MM-DD"
                      :placeholder="['开始日期', '结束日期']"
                      allow-clear
                      class="no-border-radius-picker"
                    />
                  </a-form-item>
                </a-col>
                <!-- 设备状态 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24">
                  <a-form-item label="设备状态" prop="equipmentStatus">
                    <a-select
                      v-model:value="queryParam.equipmentStatus"
                      placeholder="请选择"
                      allow-clear
                      style="width: 100%"
                      class="no-border-radius-select"
                    >
                      <a-select-option
                        v-for="(d, index) in dict.type['equipment_status']"
                        :key="index"
                        :value="d.value"
                        >{{ d.label }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <!-- 状态日期 -->
                <!--              <a-col :md="6" :sm="24">-->
                <!--                <a-form-item label="状态日期" prop="statusDate">-->
                <!--                  <a-date-picker-->
                <!--                    style="width: 100%"-->
                <!--                    v-model:value="queryParam.statusDate"-->
                <!--                    format="YYYY-MM-DD"-->
                <!--                    valueFormat="YYYY-MM-DD"-->
                <!--                    placeholder="请选择"-->
                <!--                    allow-clear-->
                <!--                    class="no-border-radius-picker"-->
                <!--                  />-->
                <!--                </a-form-item>-->
                <!--              </a-col>-->
                <!-- 状态变更人 -->
                <!--              <a-col :md="6" :sm="24">-->
                <!--                <a-form-item label="状态变更人" prop="statusName">-->
                <!--                  <a-input-->
                <!--                    v-model:value="queryParam.statusName"-->
                <!--                    placeholder="请输入"-->
                <!--                    allow-clear-->
                <!--                    class="no-border-radius-input"-->
                <!--                  />-->
                <!--                </a-form-item>-->
                <!--              </a-col>-->

                <!-- 展开后，按钮在最后一行 -->
                <a-col :xxl="6" :xl="8" :lg="12" :md="12" :sm="24" :xs="24" class="search-actions-col">
                  <a-form-item>
                    <span class="table-page-search-submitButtons" :style="submitButtonStyle">
                      <a-button type="primary" @click="handleQuery" class="search-button">搜索</a-button>
                      <span class="search-actions-group">
                        <a-button @click="resetQuery" class="no-border-button">重置</a-button>
                        <a-button @click="toggleAdvanced" class="no-border-button toggle-button">
                          {{ advanced ? '收起' : '展开' }}
                          <UpOutlined v-if="advanced" />
                          <DownOutlined v-else />
                        </a-button>
                      </span>
                    </span>
                  </a-form-item>
                </a-col>
              </template>
            </a-row>
          </a-form>
        </div>
        <!-- 操作 -->
        <div class="table-operations">
          <a-button
            type="text"
            shape="circle"
            @click="resetQuery"
            v-hasPermi="['system:equipment:refresh']"
            class="refresh-icon-button"
          >
            <img src="@/assets/images/projectUser/refresh.png" alt="刷新" />
          </a-button>
          <a-button
            type="primary"
            @click="$refs.createForm.handleAdd()"
            v-hasPermi="['system:equipment:add']"
            class="add-button"
          >
            <PlusOutlined />新增
          </a-button>
          <a-button
            @click="handleExport"
            v-hasPermi="['system:equipment:export']"
            class="no-border-button import-export-button"
          >
            <UploadOutlined />导出
          </a-button>
          <a-button
            @click="$refs.importExcel.importExcelHandleOpen()"
            v-hasPermi="['system:equipment:import']"
            class="no-border-button import-export-button"
          >
            <DownloadOutlined />导入
          </a-button>

          <a-button
            :disabled="multiple"
            @click="handleEnable"
            v-hasPermi="['system:equipment:enable']"
            class="no-border-button batch-operation-button"
          >
            <CheckCircleOutlined />启用
          </a-button>
          <a-button
            :disabled="multiple"
            @click="handleDisable"
            v-hasPermi="['system:equipment:disable']"
            class="no-border-button batch-operation-button"
          >
            <CloseCircleOutlined />暂停
          </a-button>

          <a-button
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['system:equipment:remove']"
            class="no-border-button batch-operation-button"
          >
            <DeleteOutlined />删除
          </a-button>
          <a-button
            @click="handleDownloadTemplate"
            v-hasPermi="['system:equipment:importTemplate']"
            class="no-border-button template-download-button"
          >
            <CloudDownloadOutlined />导入模板下载
          </a-button>
          <!-- <table-setting
          :style="{ float: 'right' }"
          v-model:table-size="tableSize"
          v-model:value="columns"
          :refresh-loading="loading"
          @refresh="getList"
        /> -->
        </div>
        <!-- 增加修改 -->
        <import-excel ref="importExcel" @ok="getList" />
        <create-form ref="createForm" @ok="getList" @close="getList" />
        <!-- 设备日志弹窗 -->
        <equipment-log
          :visible="equipmentLogVisible"
          :equipment-id="currentEquipmentId"
          :equipment-name="currentEquipmentName"
          @close="handleEquipmentLogClose"
        />
        <!-- 设备维护弹窗 -->
        <equipment-maintenance
          :visible="equipmentMaintenanceVisible"
          :equipment-id="currentEquipmentId"
          :equipment-name="currentEquipmentName"
          @close="handleEquipmentMaintenanceClose"
        />
        <!-- 数据表格 -->
        <a-table
          :loading="loading"
          :size="tableSize"
          rowKey="id"
          :columns="columns"
          :data-source="list"
          :row-selection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange,
            fixed: true,
          }"
          :pagination="false"
          :bordered="tableBordered"
          :scroll="{ x: 'max-content' }"
          class="optimized-table"
        >
          <!-- 使用 bodyCell 插槽自定义单元格显示 -->
          <template #bodyCell="{ column, text, record }">
            <!-- 设备类型：显示为"0传统设备"或"1机器人"格式 -->
            <template v-if="column.dataIndex === 'type'">
              <span>{{ text == 0 || text == '0' ? '传统设备' : text == 1 || text == '1' ? '机器人' : text }}</span>
            </template>
            <!-- 保养周期类型：使用字典标签显示 -->
            <template v-else-if="column.dataIndex === 'maintenanceCycle'">
              <span>
                <dict-tag :options="dict.type['equipment_maintenance_cycle_type']" :value="record.maintenanceCycle" />
              </span>
            </template>
            <!-- 是否需要耗材：使用字典标签显示 -->
            <template v-else-if="column.dataIndex === 'isConsumables'">
              <span>
                <dict-tag :options="dict.type['equipment_require_consumables']" :value="record.isConsumables" />
              </span>
            </template>
            <!-- 设备状态：使用字典标签显示 -->
            <template v-else-if="column.dataIndex === 'equipmentStatus'">
              <span>
                <dict-tag :options="dict.type['equipment_status']" :value="record.equipmentStatus" />
              </span>
            </template>
            <!-- 操作列：编辑、删除 -->
            <template v-else-if="column.dataIndex === 'operation'">
              <div class="table-action-buttons">
                <template v-if="record.specification">
                  <a
                    @click="handleInstructionPreview(record)"
                    v-hasPermi="['system:equipment:instructionManual']"
                    class="instruction-link"
                  >
                    说明书
                  </a>
                  <span class="action-divider" v-hasPermi="['system:equipment:instructionManual']">|</span>
                </template>

                <a
                  @click="handleEquipmentMaintenance(record)"
                  v-hasPermi="['system:equipment:equipmentMaintenance']"
                  class="maintenance-link"
                >
                  设备维护
                </a>
                <span class="action-divider" v-hasPermi="['system:equipment:equipmentMaintenance']">|</span>

                <a @click="handleEquipmentLog(record)" v-hasPermi="['system:equipment:deviceLog']" class="log-link">
                  设备日志
                </a>
                <span class="action-divider" v-hasPermi="['system:equipment:deviceLog']">|</span>

                <!-- <span class="action-divider" v-hasPermi="['system:equipment:edit']">|</span> -->
                <a
                  @click="$refs.createForm.handleUpdate(record, undefined)"
                  v-hasPermi="['system:equipment:edit']"
                  class="edit-link"
                >
                  编辑
                </a>
              </div>
            </template>
          </template>
        </a-table>

        <a-modal
          :visible="instructionPreviewVisible"
          :footer="null"
          :width="900"
          @cancel="handleInstructionPreviewCancel"
          :title="instructionPreviewTitle"
        >
          <div v-if="isPdfFile(instructionPreviewUrl)" style="text-align: center; margin-bottom: 10px">
            <a-button type="link" :href="instructionPreviewUrl" target="_blank" style="margin-right: 10px">
              <a-icon type="download" />下载PDF
            </a-button>
            <a-button type="link" @click="openInstructionInNewWindow"> <a-icon type="export" />在新窗口打开 </a-button>
          </div>
          <iframe
            v-if="isPdfFile(instructionPreviewUrl)"
            :src="instructionPreviewUrl"
            style="width: 100%; height: 600px; border: 1px solid #d9d9d9"
          ></iframe>
          <div v-else-if="isImageFile(instructionPreviewUrl)" style="text-align: center">
            <img :src="instructionPreviewUrl" alt="说明书预览" style="max-width: 100%; max-height: 600px" />
          </div>
          <div v-else style="text-align: center; padding: 50px">
            <a-icon type="file" style="font-size: 48px; color: #999" />
            <p style="margin-top: 16px; color: #999">暂不支持预览该文件</p>
          </div>
        </a-modal>
        <!-- 分页 -->
        <div class="pagination-wrapper">
          <div class="pagination-left">
            <span class="pagination-info">
              显示第 {{ (queryParam.pageNum - 1) * queryParam.pageSize + 1 }} 到第
              {{ Math.min(queryParam.pageNum * queryParam.pageSize, total) }} 条数据/共 {{ total }} 条
            </span>
            <a-select
              v-model:value="queryParam.pageSize"
              style="width: 100px; margin-left: 8px"
              @change="onShowSizeChange(queryParam.pageNum, queryParam.pageSize)"
              class="no-border-radius-select"
            >
              <a-select-option :value="10">10条/页</a-select-option>
              <a-select-option :value="20">20条/页</a-select-option>
              <a-select-option :value="50">50条/页</a-select-option>
              <a-select-option :value="100">100条/页</a-select-option>
            </a-select>
          </div>
          <div class="pagination-right">
            <a-pagination
              :current="queryParam.pageNum"
              :total="total"
              :page-size="queryParam.pageSize"
              :show-total="() => ''"
              @change="changeSize"
            />
            <span class="pagination-jump">
              到第
              <a-input-number
                v-model:value="jumpPage"
                :min="1"
                :max="Math.ceil(total / queryParam.pageSize)"
                style="width: 60px; margin: 0 4px"
                @pressEnter="handleJumpPage"
                class="no-border-radius-input-number"
              />
              页
            </span>
          </div>
        </div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../utils/gogocodeTransfer'
/**
 * 设备管理页面
 * 功能：提供设备的查询、新增、编辑、删除、导入导出、启用/禁用等操作
 * - 根据选中的项目ID过滤设备列表
 * - 支持按设备名称、设备码、设备型号、定位器MAC、生产厂家等条件搜索
 * - 支持高级搜索展开/收起
 * - 支持批量删除、启用、禁用
 */
import {
  SearchOutlined,
  RedoOutlined,
  UpOutlined,
  DownOutlined,
  PlusOutlined,
  UploadOutlined,
  DownloadOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  DeleteOutlined,
  CloudDownloadOutlined,
} from '@ant-design/icons-vue'
import { pageEquipment, delEquipment, changeEquipmentStatus } from '@/api/system/equipment'
import CreateForm from './modules/CreateForm'
import ImportExcel from './modules/ImportExcel'
import EquipmentLog from './modules/EquipmentLog'
import EquipmentMaintenance from './modules/EquipmentMaintenance'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Equipment',
  components: {
    CreateForm,
    ImportExcel,
    EquipmentLog,
    EquipmentMaintenance,
    SearchOutlined,
    RedoOutlined,
    UpOutlined,
    DownOutlined,
    PlusOutlined,
    UploadOutlined,
    DownloadOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    DeleteOutlined,
    CloudDownloadOutlined,
  },
  // 字典类型配置
  dicts: ['device_type', 'equipment_maintenance_cycle_type', 'equipment_require_consumables', 'equipment_status'],
  mixins: [tableMixin],
  data() {
    return {
      // 设备列表数据
      list: [],
      // 选中的行key数组
      selectedRowKeys: [],
      // 选中的行数据数组
      selectedRows: [],
      // 选中的ID数组（用于批量删除、启用/禁用等操作）
      ids: [],
      // 高级搜索展开/关闭状态
      advanced: false,
      // 非多个禁用（用于控制批量操作的按钮状态）
      multiple: true,
      // 加载状态
      loading: false,
      // 总记录数
      total: 0,
      // 查询参数（只包含表格显示的字段和分页参数）
      queryParam: {
        projectId: null, // 项目ID（从Vuex自动获取）
        name: null, // 设备名称
        equipmentCode: null, // 设备码
        equipmentModel: null, // 设备型号
        wristbandMac: null, // 定位器MAC
        manufactor: null, // 生产厂家
        type: undefined, // 设备类型
        maintenanceCycle: undefined, // 保养周期类型
        maintenanceFrequency: null, // 保养周期
        isConsumables: undefined, // 是否需要耗材
        guaranteeTimeStart: undefined, // 保修截止开始日期
        guaranteeTimeEnd: undefined, // 保修截止结束日期
        equipmentStatus: undefined, // 设备状态
        statusDate: null, // 状态日期
        statusName: null, // 状态变更人
        pageNum: 1, // 当前页码
        pageSize: 10, // 每页显示数量
      },
      // 基础列配置（不包含序号列）
      baseColumns: [
        {
          title: '设备名称',
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: '设备编码',
          dataIndex: 'equipmentCode',
          align: 'center',
        },
        {
          title: '设备型号',
          dataIndex: 'equipmentModel',
          align: 'center',
        },

        {
          title: '定位器MAC',
          dataIndex: 'wristbandMac',
          align: 'center',
        },
        {
          title: '生产厂家',
          dataIndex: 'manufactor',
          align: 'center',
        },
        {
          title: '设备类型',
          dataIndex: 'type',
          align: 'center',
          scopedSlots: { customRender: 'type' },
        },
        {
          title: '保养周期类型',
          dataIndex: 'maintenanceCycle',
          align: 'center',
          scopedSlots: { customRender: 'maintenanceCycle' },
        },
        {
          title: '保养周期',
          dataIndex: 'maintenanceFrequency',
          align: 'center',
        },
        {
          title: '是否需要耗材',
          dataIndex: 'isConsumables',
          align: 'center',
          scopedSlots: { customRender: 'isConsumables' },
        },
        {
          title: '保修截止日期',
          dataIndex: 'guaranteeTime',
          align: 'center',
        },
        {
          title: '设备状态',
          dataIndex: 'equipmentStatus',
          align: 'center',
          scopedSlots: { customRender: 'equipmentStatus' },
        },
        {
          title: '状态日期',
          dataIndex: 'statusDate',
          align: 'center',
        },
        {
          title: '状态变更人',
          dataIndex: 'statusName',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 350,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right',
        },
      ],
      instructionPreviewVisible: false,
      instructionPreviewUrl: '',
      instructionPreviewTitle: '说明书预览',
      // 设备日志弹窗相关状态
      equipmentLogVisible: false,
      // 设备维护弹窗相关状态
      equipmentMaintenanceVisible: false,
      currentEquipmentId: null,
      currentEquipmentName: '',
      // 分页跳转页码
      jumpPage: 1,
    }
  },
  computed: {
    submitButtonStyle() {
      return {}
    },
    guaranteeTimeRange: {
      get() {
        const start = this.queryParam.guaranteeTimeStart
        const end = this.queryParam.guaranteeTimeEnd
        return start && end ? [start, end] : []
      },
      set(val) {
        const start = Array.isArray(val) && val.length > 0 ? val[0] : undefined
        const end = Array.isArray(val) && val.length > 1 ? val[1] : undefined
        this.queryParam.guaranteeTimeStart = start || undefined
        this.queryParam.guaranteeTimeEnd = end || undefined
      },
    },
    // 表格列配置（使用 computed 以便在 customRender 中访问 this）
    columns() {
      const that = this
      return [
        {
          title: '序号',
          dataIndex: 'id',
          width: 80,
          align: 'center',
          customRender: ({ index }) => {
            const pageNum = that.queryParam.pageNum || 1
            const pageSize = that.queryParam.pageSize || 10
            // 确保 index 是数字类型
            const rowIndex = typeof index === 'number' ? index : 0
            return (pageNum - 1) * pageSize + rowIndex + 1
          },
        },
        ...this.baseColumns, // 保留其他列配置
      ]
    },
  },
  created() {
    // 初始化时从 Vuex 获取项目ID
    const currentProjectId = this.$store.getters.currentProjectId
    if (currentProjectId) {
      this.queryParam.projectId = currentProjectId
    }
    // 页面创建时加载数据列表
    this.getList()
    // 监听项目变化事件（使用 $root 事件总线）
    $on(this.$root, 'project-changed', this.handleProjectChanged)
  },
  beforeUnmount() {
    // 移除事件监听
    $off(this.$root, 'project-changed', this.handleProjectChanged)
  },
  methods: {
    /**
     * 查询设备列表
     * 根据查询参数分页获取设备数据
     */
    getList() {
      // 每次查询前同步 Vuex 中的当前项目ID
      const currentProjectId = this.$store.getters.currentProjectId
      if (currentProjectId) {
        this.queryParam.projectId = currentProjectId
      }
      this.loading = true
      pageEquipment(this.queryParam)
        .then((response) => {
          this.list = response.data.records
          this.total = response.data.total
          this.jumpPage = this.queryParam.pageNum
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    /**
     * 处理项目变化事件
     * 当右侧项目选择发生变化时，更新查询参数并刷新列表
     * @param {Number} projectId - 新选中的项目ID（可能为 undefined，表示清空选择）
     */
    handleProjectChanged(projectId) {
      // 更新查询参数中的项目ID
      this.queryParam.projectId = projectId || undefined
      // 重置到第一页并刷新列表
      this.queryParam.pageNum = 1
      this.getList()
    },

    /**
     * 搜索按钮操作
     * 重置到第一页并重新查询
     */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },

    /**
     * 重置按钮操作
     * 清空所有查询条件，保留项目ID（从Vuex获取）和分页参数
     */
    resetQuery() {
      // 从 Vuex 获取当前项目ID作为默认值
      const currentProjectId = this.$store.getters.currentProjectId
      this.queryParam = {
        projectId: currentProjectId || undefined, // 项目ID（从Vuex获取）
        name: undefined, // 设备名称
        equipmentCode: undefined, // 设备码
        equipmentModel: undefined, // 设备型号
        wristbandMac: undefined, // 定位器MAC
        manufactor: undefined, // 生产厂家
        type: undefined, // 设备类型
        maintenanceCycle: undefined, // 保养周期类型
        maintenanceFrequency: undefined, // 保养周期
        isConsumables: undefined, // 是否需要耗材
        guaranteeTimeStart: undefined, // 保修截止开始日期
        guaranteeTimeEnd: undefined, // 保修截止结束日期
        equipmentStatus: undefined, // 设备状态
        statusDate: undefined, // 状态日期
        statusName: undefined, // 状态变更人
        pageNum: 1, // 当前页码
        pageSize: 10, // 每页显示数量
      }
      this.handleQuery()
    },

    /**
     * 每页条数变化
     * @param {Number} current - 当前页码
     * @param {Number} pageSize - 每页条数
     */
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    /**
     * 分页变化
     * @param {Number} current - 当前页码
     * @param {Number} pageSize - 每页条数
     */
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },

    /**
     * 表格行选择变化
     * @param {Array} selectedRowKeys - 选中的行key数组
     * @param {Array} selectedRows - 选中的行数据数组
     */
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      // 更新按钮禁用状态
      this.multiple = !selectedRowKeys.length
    },

    /**
     * 切换高级搜索展开/收起
     */
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    /**
     * 删除按钮操作
     * @param {Object} row - 要删除的设备记录（可选，如果传入则删除单条，否则删除选中的多条）
     */
    handleDelete(row) {
      const that = this
      const ids = row ? row.id : this.ids
      if (row && row.id) {
        if (!this.ids.includes(row.id)) {
          this.ids.push(row.id)
        }
      }

      // 获取要删除的设备名称
      let nameText = ''
      if (row && row.name) {
        // 单行删除，显示该行的设备名称
        nameText = row.name
      } else if (this.selectedRows && this.selectedRows.length > 0) {
        // 多行删除，显示所有选中行的设备名称
        const names = this.selectedRows.map((item) => item.name).filter((name) => name)
        nameText = names.join('、')
      }

      this.$confirm({
        title: '确认删除所选中数据?',
        content: nameText ? `删除设备名称为：${nameText}` : '确认删除所选数据?',
        onOk() {
          // 批量删除
          const data = that.ids.map((id) => ({ id }))
          return delEquipment(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success('删除成功', 3)
            })
            .catch(() => {
              that.$message.error('删除失败', 3)
            })
        },
        onCancel() {
          // 取消时清空删除ids列表
          that.ids = []
        },
      })
    },

    /**
     * 导出按钮操作
     * 支持导出选中数据或当前筛选条件下的全部数据
     */
    handleExport() {
      const that = this
      const hasSelection = that.selectedRowKeys && that.selectedRowKeys.length > 0
      this.$confirm({
        title: '是否确认导出?',
        content: hasSelection ? '将导出所选数据' : '将导出当前筛选条件下的全部数据',
        onOk() {
          const params = { ...that.queryParam }
          // 如果选中了数据，则传递equipmentIds参数
          if (hasSelection) {
            params.equipmentIds = that.selectedRowKeys
          }
          that.download('system/equipment/export', params, `设备_${new Date().getTime()}.xls`)
        },
        onCancel() {},
      })
    },

    /**
     * 下载导入模板
     */
    handleDownloadTemplate() {
      this.download('system/equipment/importTemplate', {}, `设备导入模板_${new Date().getTime()}.xls`)
    },

    /**
     * 启用按钮操作
     * 批量启用选中的设备
     */
    handleEnable() {
      this.handleChangeStatus(1)
    },

    /**
     * 禁用按钮操作
     * 批量禁用选中的设备
     */
    handleDisable() {
      this.handleChangeStatus(0)
    },

    /**
     * 批量修改状态（启用/禁用）
     * @param {Number} status - 状态值，1-启用，0-禁用
     */
    handleChangeStatus(status) {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请先选择需要操作的数据', 3)
        return
      }
      const actionText = status === 1 ? '启用' : '禁用'
      const ids = [...this.selectedRowKeys].join(',')
      this.$confirm({
        title: `确认${actionText}所选中数据?`,
        content: `当前选中编号为 ${ids} 的数据`,
        onOk: () => {
          const data = {
            ids,
            status: status,
          }
          return changeEquipmentStatus(data)
            .then(() => {
              this.$message.success(`${actionText}成功`, 3)
              this.onSelectChange([], [])
              this.getList()
            })
            .catch(() => {
              this.$message.error(`${actionText}失败`, 3)
            })
        },
      })
    },
    handleInstructionPreview(record) {
      if (!record || !record.specification) {
        this.$message.warning('该设备尚未上传说明书', 3)
        return
      }
      this.instructionPreviewUrl = record.specification
      this.instructionPreviewTitle = `${record.name || '说明书'}预览`
      this.instructionPreviewVisible = true
    },
    handleInstructionPreviewCancel() {
      this.instructionPreviewVisible = false
      this.instructionPreviewUrl = ''
    },
    openInstructionInNewWindow() {
      if (this.instructionPreviewUrl) {
        window.open(this.instructionPreviewUrl, '_blank')
      }
    },
    isPdfFile(url) {
      if (!url) return false
      const lower = url.toLowerCase()
      return lower.endsWith('.pdf') || lower.includes('.pdf?')
    },
    isImageFile(url) {
      if (!url) return false
      const lower = url.toLowerCase()
      const exts = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp']
      return exts.some((ext) => lower.includes(ext))
    },
    /**
     * 打开设备日志弹窗
     * @param {Object} record - 设备记录
     */
    handleEquipmentLog(record) {
      if (!record || !record.id) {
        this.$message.warning('设备信息不完整', 3)
        return
      }
      this.currentEquipmentId = record.id
      this.currentEquipmentName = record.name || ''
      this.equipmentLogVisible = true
    },
    /**
     * 关闭设备日志弹窗
     */
    handleEquipmentLogClose() {
      this.equipmentLogVisible = false
      this.currentEquipmentId = null
      this.currentEquipmentName = ''
    },
    /**
     * 打开设备维护弹窗
     * @param {Object} record - 设备记录
     */
    handleEquipmentMaintenance(record) {
      if (!record || !record.id) {
        this.$message.warning('设备信息不完整', 3)
        return
      }
      this.currentEquipmentId = record.id
      this.currentEquipmentName = record.name || ''
      this.equipmentMaintenanceVisible = true
    },
    /**
     * 关闭设备维护弹窗
     */
    handleEquipmentMaintenanceClose() {
      this.equipmentMaintenanceVisible = false
      this.currentEquipmentId = null
      this.currentEquipmentName = ''
    },
    /**
     * 分页跳转
     */
    handleJumpPage() {
      if (this.jumpPage && this.jumpPage >= 1) {
        const maxPage = Math.ceil(this.total / this.queryParam.pageSize)
        if (this.jumpPage > maxPage) {
          this.jumpPage = maxPage
        }
        this.queryParam.pageNum = this.jumpPage
        this.getList()
      }
    },
  },
}
</script>

<style scoped>
/* 条件搜索区域样式 */
.table-page-search-wrapper :deep(.ant-form-item-label) {
  width: 80px;
  min-width: 80px;
  flex: 0 0 80px !important;
  max-width: 80px !important;
}

.table-page-search-wrapper :deep(.ant-form-item-label > label) {
  width: 100%;
  text-align: right;
}

/* 让搜索栏的 FormItem 在一行内左右排布：左侧文字固定宽度，右侧输入区域自适应 */
.table-page-search-wrapper :deep(.ant-form-item) {
  width: 100%;
}

.table-page-search-wrapper :deep(.ant-form-item-row) {
  flex-wrap: nowrap;
}

.table-page-search-wrapper :deep(.ant-form-item-control) {
  flex: 1 1 0 !important;
  max-width: none !important;
  margin-left: 8px;
  min-width: 0;
}

.table-page-search-wrapper :deep(.ant-form-item-control-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input-content) {
  width: 100%;
  min-width: 0;
}

/* 移除所有输入框圆角的通用样式 */
.no-border-radius-input :deep(.ant-input) {
  border-radius: 0 !important;
}

.no-border-radius-input :deep(.ant-input-affix-wrapper) {
  border-radius: 0 !important;
}

/* 通用规则：当 input 在 affix-wrapper 内时，必须去掉边框避免嵌套 - 最高优先级 */
/* 覆盖所有边框相关属性 */
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper > .ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper input.ant-input),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:hover),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:focus),
.no-border-radius-input :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

.no-border-radius-picker :deep(.ant-picker) {
  border-radius: 0 !important;
}

.no-border-radius-select :deep(.ant-select-selector) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.no-border-radius-input-number :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 搜索区域输入框样式覆盖 - 优先级高于 no-border-radius-input */
/* 普通输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input),
.table-page-search-wrapper :deep(.ant-form-item-control-input .ant-input) {
  width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框外层样式 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper) {
  width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
/* 覆盖所有边框相关属性，确保内部input在所有状态下都隐藏边框 */
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper input.ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper .ant-input:not(:focus):not(:hover)),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper > .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:hover),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper .ant-input-focused) {
  border: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 0 !important;
  border-left: 0 !important;
  border-width: 0 !important;
  border-style: none !important;
  border-color: transparent !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  width: 100% !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
}

/* 移除搜索栏输入框、下拉选择框、日期选择框聚焦时的高亮效果 */
/* 输入框聚焦样式 - 内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-focused),
.table-page-search-wrapper :deep(.ant-input:focus),
.table-page-search-wrapper :deep(.ant-input-focused) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 带前缀/后缀的输入框聚焦样式 - 外部容器保持边框，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 聚焦时，内部input隐藏边框 */
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.no-border-radius-input .ant-input-affix-wrapper-focused .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper:focus .ant-input),
.table-page-search-wrapper :deep(.ant-input-affix-wrapper-focused .ant-input) {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 下拉选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector:focus),
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-focused .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector:focus),
.table-page-search-wrapper :deep(.ant-select-focused .ant-select-selector) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择框聚焦样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker:focus),
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker-focused),
.table-page-search-wrapper :deep(.ant-picker:focus),
.table-page-search-wrapper :deep(.ant-picker-focused) {
  border: 1px solid #c7c7c7 !important;
  box-shadow: none !important;
  outline: none !important;
}

/* 日期选择器样式 */
.table-page-search-wrapper :deep(.no-border-radius-picker .ant-picker),
.table-page-search-wrapper :deep(.ant-picker) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框样式 */
.table-page-search-wrapper :deep(.no-border-radius-select .ant-select-selector),
.table-page-search-wrapper :deep(.ant-select-selector) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 下拉选择框容器样式 */
.table-page-search-wrapper :deep(.no-border-radius-select.ant-select),
.table-page-search-wrapper :deep(.ant-select) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
}

/* 数字输入框样式 */
.table-page-search-wrapper :deep(.no-border-radius-input-number .ant-input-number),
.table-page-search-wrapper :deep(.ant-input-number) {
  width: 100% !important;
  min-width: auto !important;
  max-width: 100% !important;
  background: #ffffff !important;
  border-radius: 4px 4px 4px 4px !important;
  border: 1px solid #c7c7c7 !important;
}

/* 搜索按钮和新增按钮样式 */
.search-button,
.add-button {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  margin-right: 8px;
}

.search-button:hover,
.add-button:hover {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
}

.search-button:focus,
.add-button:focus {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 其他按钮圆角设置 */
.table-page-search-wrapper :deep(.ant-btn) {
  border-radius: 4px;
}

.table-page-search-submitButtons {
  flex-wrap: wrap;
}

.search-actions-col {
  display: flex;
  justify-content: flex-end;
}

.search-actions-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

@media (max-width: 992px) {
  .table-page-search-wrapper :deep(.ant-form-item-row) {
    flex-wrap: wrap;
  }

  .table-page-search-wrapper :deep(.ant-form-item-label) {
    width: auto;
    min-width: 0;
    flex: 0 0 auto !important;
    max-width: none !important;
  }

  .table-page-search-wrapper :deep(.ant-form-item-label > label) {
    width: auto;
    text-align: left;
  }

  .table-page-search-wrapper :deep(.ant-form-item-control) {
    flex: 1 1 100% !important;
    max-width: none !important;
    margin-left: 0;
  }

  .search-actions-col {
    justify-content: flex-start;
  }
}

.table-operations :deep(.ant-btn) {
  border-radius: 4px;
}

/* 全局按钮圆角设置 */
:deep(.ant-btn) {
  border-radius: 4px !important;
}

/* 分页组件样式 - 去掉圆角 */
.pagination-wrapper :deep(.ant-btn) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-item) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev),
.pagination-wrapper :deep(.ant-pagination-next),
.pagination-wrapper :deep(.ant-pagination-prev .ant-pagination-item-link),
.pagination-wrapper :deep(.ant-pagination-next .ant-pagination-item-link) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-pagination-prev button),
.pagination-wrapper :deep(.ant-pagination-next button) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number) {
  border-radius: 0 !important;
}

.pagination-wrapper :deep(.ant-input-number-input) {
  border-radius: 0 !important;
}

/* 分页选中页数样式 */
.pagination-wrapper :deep(.ant-pagination-item-active) {
  background: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active a) {
  color: #ffffff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover) {
  background: #165dff !important;
  border-color: #165dff !important;
}

.pagination-wrapper :deep(.ant-pagination-item-active:hover a) {
  color: #ffffff !important;
}

/* 去掉指定按钮的边框 */
.no-border-button {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button:hover,
.no-border-button:focus {
  border: none !important;
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

/* 重置按钮样式（确保样式正确） */
.no-border-button:not(.toggle-button) {
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

.no-border-button:not(.toggle-button):hover,
.no-border-button:not(.toggle-button):focus {
  background-color: #f3f3f3 !important;
  color: #101010 !important;
}

/* 导入导出按钮背景颜色 */
.import-export-button {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-export-button :deep(.anticon) {
  color: #333 !important;
}

.import-export-button:hover,
.import-export-button:focus {
  background: #f3f3f3 !important;
  color: #333 !important;
}

.import-export-button:hover :deep(.anticon),
.import-export-button:focus :deep(.anticon) {
  color: #333 !important;
}

/* 展开/收起按钮文字和图标颜色，去掉底部阴影 */
.toggle-button {
  color: #165dff !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

.toggle-button :deep(.anticon) {
  color: #165dff !important;
}

/* 导入模板下载按钮文字和图标颜色，去掉底部阴影 */
.no-border-button.template-download-button {
  color: #165dff !important;
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.no-border-button.template-download-button :deep(.anticon) {
  color: #165dff !important;
}

.no-border-button.template-download-button:hover,
.no-border-button.template-download-button:focus {
  color: #165dff !important;
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.no-border-button.template-download-button:hover :deep(.anticon),
.no-border-button.template-download-button:focus :deep(.anticon) {
  color: #165dff !important;
}

/* 批量操作按钮样式（启用、暂停、删除）- 参照 projectUser 页面的修改状态按钮 */
.batch-operation-button {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

.batch-operation-button:hover,
.batch-operation-button:focus {
  color: #333333 !important;
}

.batch-operation-button:disabled {
  color: rgba(0, 0, 0, 0.25) !important;
}

.toggle-button:hover,
.toggle-button:focus {
  color: #165dff !important;
  background-color: transparent !important;
  box-shadow: none !important;
}

.toggle-button:hover :deep(.anticon),
.toggle-button:focus :deep(.anticon) {
  color: #165dff !important;
}

.table-page-search-wrapper {
  margin-bottom: 16px;
}

.table-operations {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.refresh-icon-button {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pagination-wrapper {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-left {
  display: flex;
  align-items: center;
}

.pagination-info {
  color: rgba(0, 0, 0, 0.65);
}

.pagination-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.pagination-jump {
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.65);
}

/* 优化表格样式 */
.optimized-table :deep(.ant-table-thead > tr > th) {
  white-space: nowrap; /* 表头不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: #fafafa;
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #333333;
}

.optimized-table :deep(.ant-table-tbody > tr > td) {
  white-space: nowrap; /* 表格内容不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 12px 8px; /* 增加内边距 */
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 操作列固定右侧样式 */
.optimized-table :deep(.ant-table-tbody > tr > td:last-child) {
  position: sticky;
  right: 0;
  background: white;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 选中行的操作列样式 */
.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected > td:last-child) {
  position: sticky;
  right: 0;
  background: white !important;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td:last-child) {
  position: sticky;
  right: 0;
  background: #f5f5f5 !important;
  z-index: 10;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-thead > tr > th:last-child) {
  position: sticky;
  right: 0;
  background: #fafafa;
  z-index: 11;
  box-shadow: -2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 行悬停效果 */
.optimized-table :deep(.ant-table-tbody > tr:hover > td) {
  background-color: #f5f5f5;
}

/* 去掉表格边框 */
:deep(.ant-table) {
  border: none !important;
}

:deep(.ant-table-container) {
  border: none !important;
}

:deep(.ant-table-thead > tr > th) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-thead > tr > th:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr > td) {
  border-bottom: 1px solid #f0f0f0 !important;
  border-right: none !important;
}

:deep(.ant-table-tbody > tr > td:first-child) {
  border-left: none !important;
}

:deep(.ant-table-tbody > tr:last-child > td) {
  border-bottom: none !important;
}

/* 表格滚动条样式优化 */
:deep(.ant-table-body) {
  overflow-x: auto !important;
  scrollbar-width: thin;
  scrollbar-color: #d9d9d9 #f5f5f5;
}

:deep(.ant-table-body::-webkit-scrollbar) {
  height: 8px;
}

:deep(.ant-table-body::-webkit-scrollbar-track) {
  background: #f5f5f5;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb) {
  background: #d9d9d9;
  border-radius: 4px;
}

:deep(.ant-table-body::-webkit-scrollbar-thumb:hover) {
  background: #bfbfbf;
}

/* 序号列样式优化 */
:deep(.ant-table-tbody > tr > td:first-child) {
  font-family: PingFang SC, PingFang SC !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  color: #333333 !important;
}

/* 选中的行样式 - 去掉背景色 */
:deep(.ant-table-tbody > tr.ant-table-row-selected > td) {
  background-color: transparent !important;
}

:deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td) {
  background-color: transparent !important;
}

/* 表格复选框样式 */
.optimized-table :deep(.ant-checkbox-inner) {
  width: 16px !important;
  height: 16px !important;
  border-radius: 0 !important;
  border-color: #999999 !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked .ant-checkbox-inner::after) {
  border-color: #ffffff !important;
}

.optimized-table :deep(.ant-checkbox:hover .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-input:focus + .ant-checkbox-inner) {
  border-color: #165dff !important;
}

.optimized-table :deep(.ant-checkbox-checked:hover .ant-checkbox-inner) {
  background-color: #165dff !important;
  border-color: #165dff !important;
}

/* 表格复选框列固定左侧样式 */
.optimized-table :deep(.ant-table-thead > tr > th:first-child) {
  position: sticky;
  left: 0;
  background: #fafafa;
  z-index: 12;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr > td:first-child) {
  position: sticky;
  left: 0;
  background: white;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected > td:first-child) {
  position: sticky;
  left: 0;
  background: white !important;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

.optimized-table :deep(.ant-table-tbody > tr.ant-table-row-selected:hover > td:first-child) {
  position: sticky;
  left: 0;
  background: #f5f5f5 !important;
  z-index: 11;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
}

/* 复选框列中的复选框层级 */
.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox-wrapper),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox-wrapper) {
  position: relative;
  z-index: 13;
}

.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox) {
  position: relative;
  z-index: 13;
}

.optimized-table :deep(.ant-table-thead > tr > th:first-child .ant-checkbox-inner),
.optimized-table :deep(.ant-table-tbody > tr > td:first-child .ant-checkbox-inner) {
  position: relative;
  z-index: 13;
}

/* 操作列按钮基础样式 */
.table-action-buttons a {
  cursor: pointer;
  white-space: nowrap; /* 防止操作按钮换行 */
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  text-align: left;
}

/* 说明书按钮样式 */
.table-action-buttons .instruction-link {
  color: #534ab0 !important;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  text-align: left;
}

.table-action-buttons .instruction-link:hover {
  color: #534ab0 !important;
  opacity: 0.8;
}

/* 设备维护按钮样式 */
.table-action-buttons .maintenance-link {
  color: #34c56a !important;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  text-align: left;
}

.table-action-buttons .maintenance-link:hover {
  color: #34c56a !important;
  opacity: 0.8;
}

/* 设备日志按钮样式 */
.table-action-buttons .log-link {
  color: #333333 !important;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  text-align: left;
}

.table-action-buttons .log-link:hover {
  color: #333333 !important;
  opacity: 0.8;
}

/* 编辑按钮样式 */
.table-action-buttons .edit-link {
  color: #165dff !important;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  text-align: left;
}

.table-action-buttons .edit-link:hover {
  color: #4080ff !important;
}

.action-divider {
  margin: 0 8px;
  color: #d9d9d9;
  white-space: nowrap;
}

/* 弹窗按钮样式 - 所有按钮圆角设置为 4px */
:deep(.ant-modal-footer .ant-btn) {
  border-radius: 4px !important;
}

/* 确认按钮（主要按钮）样式 */
:deep(.ant-modal-footer .ant-btn-primary) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  color: #ffffff !important;
}

/* 确认按钮悬停状态 */
:deep(.ant-modal-footer .ant-btn-primary:hover:not(:disabled)) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

/* 确认按钮聚焦状态 */
:deep(.ant-modal-footer .ant-btn-primary:focus:not(:disabled)) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

/* 确认按钮激活状态 */
:deep(.ant-modal-footer .ant-btn-primary:active:not(:disabled)) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

/* 取消按钮（默认按钮）样式 */
:deep(.ant-modal-footer .ant-btn-default) {
  border-radius: 4px !important;
}
</style>

<style>
/* 确认弹窗按钮样式 */
.ant-modal-confirm .ant-modal-confirm-btns .ant-btn {
  border-radius: 4px !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:focus:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-primary:active:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

.ant-modal-confirm .ant-modal-confirm-btns .ant-btn-default {
  border-radius: 4px !important;
}

/* Modal 按钮样式 - 全局样式确保生效 */
.ant-modal-footer .ant-btn {
  border-radius: 4px !important;
}

/* 取消按钮样式 */
.ant-modal-footer .ant-btn-default {
  border-radius: 4px !important;
}

/* 确定按钮样式 */
.ant-modal-footer .ant-btn-primary {
  background-color: #165dff !important;
  border-color: #165dff !important;
  border-radius: 4px !important;
  color: #ffffff !important;
}

.ant-modal-footer .ant-btn-primary:hover:not(:disabled) {
  background-color: #4080ff !important;
  border-color: #4080ff !important;
  color: #ffffff !important;
}

.ant-modal-footer .ant-btn-primary:focus:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}

.ant-modal-footer .ant-btn-primary:active:not(:disabled) {
  background-color: #165dff !important;
  border-color: #165dff !important;
  color: #ffffff !important;
}
</style>
